import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { AcceptInvitePage } from '@/pages/authentication/ui/AcceptInvitePage'

const acceptInviteSearchSchema = z.object({
  token: z.string().catch(''),
})

export const Route = createFileRoute('/accept-invite')({
  validateSearch: acceptInviteSearchSchema,
  component: AcceptInvitePage,
})
